import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const NO_OPTIONS = 'NO_OPTIONS-'
export const QUESTION = 'QUESTION-'
export const BANNER = 'BANNER-'

export default {
  [PORTUGUESE]: {
    [NO_OPTIONS]: 'Não existem questões válidas para realizar o Cross Tab.',
    [QUESTION]: 'Questão',
    [BANNER]: 'Banner',
  },

  [ENGLISH]: {
    [NO_OPTIONS]: 'Not enough valid options to Cross Tab',
    [QUESTION]: 'Question',
    [BANNER]: 'Banner',
  },

  [SPANISH]: {
    [NO_OPTIONS]: 'No hay preguntas válidas para realizar el Cross Tab',
    [QUESTION]: 'Question',
    [BANNER]: 'Banner',
  },
}
